import { render, staticRenderFns } from "./WarehouseTransfer__Create.vue?vue&type=template&id=97b99334&scoped=true&"
import script from "./WarehouseTransfer__Create.vue?vue&type=script&lang=js&"
export * from "./WarehouseTransfer__Create.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseTransfer__Create.vue?vue&type=style&index=0&id=97b99334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b99334",
  null
  
)

export default component.exports